import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Agenda.css'; // Tambahkan file CSS terpisah

const Agenda = () => {
  return (
    <>
      <Navbar />
      <header className="header-banner" id="beranda">
        <h1>AGENDA <span>STANDAR KOMPETENSI KERJA NASIONAL INDONESIA</span></h1>
      </header>

      <div className="calendar-container">
        <iframe
          src="https://calendar.google.com/calendar/embed?src=komiteskktransportasi%40gmail.com&ctz=Asia%2FJakarta"
          style={{ border: 0 }}
          width="800"
          height="600"
          title="Agenda Kalender"
        ></iframe>
      </div>
      <Footer />
    </>
  );
};

export default Agenda;
